import styled from 'styled-components';
import { Textarea } from 'react-rainbow-components';
import ButtonIcon from 'components/ButtonIcon';
import { DIVIDER, GREY_400 } from '../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;
`;

export const StyledLabel = styled.span`
    margin-left: 0;
    margin-bottom: 0.25rem;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.375rem;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${DIVIDER};
    border-radius: 0.375rem;
    overflow: hidden;
`;

export const StyledTextarea = styled(Textarea)`
    display: flex;
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;

    label {
        display: none;
    }

    > div {
        border: none;
        box-shadow: none;
        box-sizing: border-box;
    }

    textarea {
        width: 100%;
        box-sizing: border-box;
        border: none;
        border-radius: 0;
        padding: 0.5rem 0.875rem;

        :focus, :active {
            width: 100%;
            padding: 0.5rem 0.875rem;
            border: none;
            box-shadow: none;
        }

        ::placeholder {
            font-weight: 300 !important;
        }
    }

    div[id^="error-message"] {
        align-self: flex-start;
        padding: 0 0.875rem 0.5rem;
    }
`;

export const ActionButton = styled(ButtonIcon)`
    width: 3rem;
    height: 3rem;

    svg {
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }
`;

export const ActionsContainer = styled.div`
    display: flex;
    position: relative;
    padding: 0.25rem 0.875rem;
    align-items: flex-start;
    align-self: stretch;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0.875rem;
        right: 0.875rem;
        border-top: 1px solid ${DIVIDER};
    }
`;

export const DictateFormContainer = styled(InputWrapper)`
    padding: 0.5rem 0.875rem;

    & > div {
        margin: 0;
        border: none;
        border-radius: 0;
    }
`;

export const DictateFormLabel = styled(StyledLabel)`
    color: ${GREY_400};
`;
